// ##### 25-05-02 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import ToursAutocompleteDiv from './ToursAutocompleteDiv';

// ##### Komarov 2025-07-23
const ToursAutocompleteOuterDivTag = ({
  transform,
  props,
  geo,
  setOpen,
  open,
  tourValue,
  optionChecker,
  setTourValue,
  setPickedTourValue
}) => {
  return (
    <div style={{ transform }} data-component="AutocompleteOuterDivTag">
      {/* ##### 23-11-21 Komarov */}
      <ToursAutocompleteDiv
        height="37px"
        props={props}
        geo={geo}
        setOpen={setOpen}
        open={open}
        tourValue={tourValue}
        optionChecker={optionChecker}
        setTourValue={setTourValue}
        setPickedTourValue={setPickedTourValue}
      />
    </div>
  );
};

export default ToursAutocompleteOuterDivTag;
